// extracted by mini-css-extract-plugin
module.exports = {"input":"ImageSelection_input__1jK5f","inputDisabled":"ImageSelection_inputDisabled__Y1a5A"};